// has, hasAlpha and modes list were taken from Vuetify ColorPicker utils code to use the same logic

// eslint-disable-next-line @typescript-eslint/ban-types
export function has(obj: object, key: string[]) {
    return key.every((k) => k in obj);
}

export function hasAlpha(
    color:
        | string
        | {
              r?: 0;
              g?: 0;
              b?: 0;
              a?: 1;
              h?: 0;
              s?: 0;
              l?: 0;
              alpha?: 1;
          },
) {
    if (!color) return false;

    if (typeof color === 'string') {
        return color.length > 7;
    }

    if (typeof color === 'object') {
        return has(color, ['a']) || has(color, ['alpha']);
    }

    return false;
}

const modesWithAlpha = {
    hexa: 'hexa',
    rgba: 'rgba',
    hsla: 'hsla',
    hsva: 'hsva',
};

export const isAlphaMode = (mode: string) => Boolean(modesWithAlpha[mode]);
